import fetch from 'auth/FetchInterceptor'

const attemptService = {}

attemptService.getQuestionPaper = function ({sessionId}) {
  return fetch({
    url: `/attempt/${sessionId}/paper`,
    method: 'get',
    params: {},
    cache: true
  })
}

attemptService.getExamAttempts = function ({examId}) {
  return fetch({
    url: `/attempt/exam/${examId}`,
    method: 'get',
    params: {},
    cache: false
  })
}

attemptService.getSessionAttempts = function ({sessionId}) {
  return fetch({
    url: `/attempt/${sessionId}`,
    method: 'get',
    params: {},
    cache: false
  })
}

attemptService.getExamAttemptsAnalysis = function ({examId}) {
  return fetch({
    url: `/attempt/exam/${examId}/analysis`,
    method: 'get',
    params: {},
    cache: false
  })
}

attemptService.getSessionAttemptsAnalysis = function ({sessionId}) {
  return fetch({
    url: `/attempt/${sessionId}/analysis`,
    method: 'get',
    params: {},
    cache: false
  })
}

attemptService.getAttemptAnalysisReportUrl = function ({key}) {
  return fetch({
    url: `/file/reportUrl`,
    method: 'post',
    data: {key},
    cache: false
  })
}

attemptService.getSessionAttempt = function ({sessionId, attemptId}) {
  return fetch({
    url: `/attempt/${sessionId}/${attemptId}`,
    method: 'get',
    params: {},
    cache: false
  })
}

attemptService.createAttempt = function ({sessionId}) {
  return fetch({
    url: `/attempt/${sessionId}`,
    method: 'post',
    params: {},
    cache: false
  })
}

attemptService.createEvent = function (data) {
  return fetch({
    url: `/attempt/event`,
    method: 'post',
    data,
    cache: false
  })
}

attemptService.submitAttempt = function ({sessionId, attemptId}) {
  return fetch({
    url: `/attempt/${sessionId}/${attemptId}`,
    method: 'post',
    params: {},
    cache: false
  })
}

export default attemptService